// extracted by mini-css-extract-plugin
export default {"account":"BigCard_account__dDbLw","balance":"BigCard_balance__CyFBd","type":"BigCard_type__St4s5"};